import { jsx as e } from "react/jsx-runtime";
import { twJoin as t } from "tailwind-merge";
import { isBlackContrast as s } from "../themes/utils/get-text-color-contrast.mjs";
import { useDesignContext as a } from "../providers/use-design-provider.mjs";
const l = ({ children: r }) => {
  const {
    state: { tertiaryColor: o }
  } = a();
  return /* @__PURE__ */ e(
    "div",
    {
      className: t(
        "bg-THEME-secondary relative w-full rounded-none border pb-5 sm:mb-5 sm:mt-5 sm:max-w-xl sm:rounded-lg sm:pb-0",
        s(o) ? "sm:shadow-around-sm border-transparent" : "sm:border-THEME-border-tertiary border-transparent"
      ),
      children: r
    }
  );
};
export {
  l as default
};
